var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('b-icon',{attrs:{"icon":_vm.icon,"variant":"primary","scale":"1.2"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }